import {module} from 'modujs';
import Utils from "../utils/utils";

export default class extends module {
  constructor(m) {
    super(m);

    console.log("✅Lexique✅")

    this.navStyle = {
      disabled: '#E8E9EC',
      active: '#1C2544'
    }

    this.cards = this.el.querySelectorAll('.lexique-item')
    this.filters = this.el.querySelectorAll('span')

  }

  init() {
    let self = this;

    self.filters.forEach(item => {
      item.addEventListener('click', () => {
        self.verifyColor(item)
        self.manager(item)
      })
    })
  }

  verifyColor(item) {
    this.filters.forEach(filter => {
      if (filter === item) {
        filter.style.color = this.navStyle.active
      } else {
        filter.style.color = this.navStyle.disabled
      }
    })
  }


  manager(item) {
    this.filter(item.dataset.filter)
  }

  filter(state) {
    const ArrayFilter = [];

    this.cards.forEach(item => {
      if (item.dataset.filter != state) {
        ArrayFilter.push(item);
      }
    })

    this.cards.forEach(item => {
      if (ArrayFilter.includes(item)) {
        item.style.display = 'none'
      } else {
        item.style.display = ''
      }
    })
  }

  destroy() {
    console.log('Destroy Filter 💥✅')
    this.filters.forEach(el => {
      el.removeEventListener('change', this)
    })
  }
}





// WEBPACK FOOTER //
// ./scripts/modules/lexique.js